import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { selectTourState } from 'features/tour/tourSelectors';

import { useAppSelector } from 'hooks/useTypedRedux';

import styles from './TourContent.module.scss';

interface TourContentProps {
  headerKey: ReactNode;
  subheaderKey: ReactNode;
}

const TourContent = ({ headerKey, subheaderKey }: TourContentProps) => {
  const { t } = useTranslation();

  const translate = (value: string) =>
    (t as unknown as (key: string) => string)(value);

  const state = useAppSelector(selectTourState);
  const { stepIndex, steps } = state;

  const renderContent = (value: ReactNode) => {
    if (typeof value === 'string') {
      return translate(value);
    }
    return value;
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        {`${renderContent(headerKey)} ${stepIndex + 1}/${steps.length}`}
      </div>
      <div className={styles.subheader}>{renderContent(subheaderKey)}</div>
    </div>
  );
};

export default TourContent;
